import * as React from 'react';
import PeoplePicker from '../utils/CustomPeoplePicker';
import {
    convertWrapperToUserObj,
    convertUserObjToWrapper,
} from '../utils/People/FormatPeoplePicker';
import { IPersonFieldProps, IPersonFieldState } from './IPersonField';
import { IUserPersonaField } from '../Activity/interfaces/IActivityForm';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export default class PersonField extends React.Component<IPersonFieldProps,IPersonFieldState> {
    constructor(props:IPersonFieldProps) {
        super(props);
        this.state = {
            selectedPeople: [],
            pickrKey: uuidv4(),
        };
    }
    componentDidMount() {
        const {people} = this.props;
        let selectedPeople = [];
        selectedPeople = convertUserObjToWrapper(people);
        this.setState({
            selectedPeople: selectedPeople,
            pickrKey: uuidv4(),
        });
    }
    componentDidUpdate(prevProps:IPersonFieldProps, preState:IPersonFieldState) {
        const {people} = this.props;
        let selectedPeople = [];
        selectedPeople = convertUserObjToWrapper(people);
        if (prevProps.people.length !== people.length) {
            this.setState({
                selectedPeople: selectedPeople,
                pickrKey: uuidv4(),
            });
        }
        if (this.CheckPersonsInFeld(prevProps.people, people) || this.CheckPersonsInFeld(people, prevProps.people)) {
            this.setState({
                selectedPeople: selectedPeople,
                pickrKey: uuidv4(),
            });
        }
    }
    CheckPersonsInFeld = (prevPeople :IUserPersonaField[],CurrPeople: IUserPersonaField[]) =>{
        let flag:boolean = false;
        var currPeopleEmail:string[] = _.map(CurrPeople,'Email');
        for (let people = 0; people < prevPeople.length; people++) {
            const prevPerson:IUserPersonaField = prevPeople[people];
            if(currPeopleEmail.indexOf(prevPerson.Email) === -1){
                flag = true;
            }
        }
        return flag;
    }
    updateSelection = (items:IUserPersonaField []) => {
        this.setState({
            selectedPeople: items,
        });
        this.handleAddClick(items);
    };
    handleAddClick = (items:IUserPersonaField[]) => {
        let selectedUsers = [];
        selectedUsers = convertWrapperToUserObj(items);
        this.props.updatePeoplePickerChange(selectedUsers, this.props.property);
    };
    render() {
        const {selectedPeople, pickrKey} = this.state;
        const {viewForm,description,multiple,getGroups} = this.props;
        return (
            <div style={viewForm?{border: '1px solid'}:{}}>
                <PeoplePicker
                    required={true}
                    disabled={viewForm}
                    multiple={multiple}
                    getGroups={getGroups}
                    description= {description}
                    placeholderTxt={this.props.placeholderTxt}
                    key={pickrKey}
                    updateSelection={this.updateSelection}
                    selectedPeople={selectedPeople}
                />
            </div>
        );
    }
}